import React from 'react'
import Questions_Table from '../../utilities/tableQuestionnaire/questionnaire_custom_answers'
import {Table} from 'react-bootstrap'
import Part1 from './umsars_p1_data.json'

class Part extends React.Component {
    constructor(props){
        super(props)
        this.state = {score:0}
    }
    handleScore = (val) => {
        if (!isNaN(val)){
            this.setState((prevState) => 
                        ({
                            ...prevState,
                            score:prevState.score + (val)

                        })
                        
            )
        }
        
    }
    componentDidUpdate(prevProps,prevState){
        if (prevState != this.state){
           this.props.score (this.props.score_name,this.state.score)
        }
    }
    componentDidMount(){
        if(this.props.data!=null){
           
            if(this.props.data[this.props.indexKey+'_score'] == parseInt(this.props.data[this.props.indexKey+'_score'],10)){
                this.setState({score:parseInt(this.props.data[this.props.indexKey+'_score'],10)})
            }
            else{
                this.setState({score:0})
            }
           
        }
    }
    render(){
        return (
            <div>
            <h4>{this.props.title}</h4>
            <Questions_Table  score={true} scoreFunc={this.handleScore} disabled={this.props.disabled} data={this.props.data!=null?this.props.data:null}questions={this.props.questions} answers={this.props.questions} handler={this.props.onChange} fieldName={'fab'}/>
            {this.props.indexKey !='p4' && 
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Score:</th>
                                        <th width={100}>{this.state.score}</th>
                                    </tr>
                                </thead>
                            </Table>
                            
                            
                            }
            </div>
        )
    }
}
Part.defaultProps = {
    data:null
}
export default Part